<span [matTooltip]="skjulTooltip()?'':tooltiptekst()">
  @if (url()) {
    <img [ngSrc]="url()!" width="120" height="120" class="bilde" [alt]="imgAltTekst()"/>
  } @else if (initialer() != null) {
    <div class="initialer">{{ initialer() }}</div>
  } @else {
    <div class="avatar-sirkel ikon std-nedtonet" [class]="ikon"></div>
  }
</span>

<!--
<div class="wk-avatar {{$ctrl.stil}}" e2e-avatar-initialer="{{$ctrl.initialer}}">
  <fk-xhr-img ng-if="$ctrl.url" url="$ctrl.url" img-class="avatar-sirkel bilde"></fk-xhr-img>
  <div ng-if="!$ctrl.url && $ctrl.initialer" class="avatar-sirkel initialer std-nedtonet">{{$ctrl.initialer}}</div>
  <div ng-if="!$ctrl.url && !$ctrl.initialer" class="avatar-sirkel standardavatar std-nedtonet {{$ctrl.ikon}}"></div>
  <md-tooltip md-direction="bottom" ng-if="$ctrl.medlem && $ctrl.skjulTooltip !== 'true'">
    {{$ctrl.medlem.navn}}, {{$ctrl.medlem.rolle.tittel}} {{$ctrl.tilgangsstatus}}
  </md-tooltip>
  <md-tooltip md-direction="bottom" ng-if="$ctrl.bruker && $ctrl.skjulTooltip !== 'true'">
    {{$ctrl.bruker.navnEllerEpost}}
  </md-tooltip>
  <md-tooltip md-direction="bottom" ng-if="$ctrl.navn && $ctrl.skjulTooltip !== 'true'">
    {{$ctrl.navn}}
  </md-tooltip>
  <md-tooltip md-direction="bottom" ng-if="!$ctrl.bruker && !$ctrl.medlem && !$ctrl.navn && $ctrl.skjulTooltip !== 'true'">
    <translate>Ansvarlig ikke angitt</translate>
  </md-tooltip>
</div>
-->




